var WkSellerList = $.noConflict(true);
(function($){
  if(WkSellerList('.wk-seller-listing-responsive').length){
    WkSellerList('.wk-seller-listing-responsive').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button" data-role="none"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button" data-role="none"></button>',
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 8,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1510,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
    
})(WkSellerList);


(function () {
  function podpisz() {
    document.querySelectorAll('.wk-slider-img').forEach(function (img) {
      if (img.dataset.podpisane) return;

      const nazwa = (img.alt || '').trim();
      if (!nazwa) return;

      const rodzic = img.parentElement;
      if (!rodzic) return;

      const wrap = document.createElement('span');
      wrap.className = 'wk-seller-wrap';

      rodzic.insertBefore(wrap, img);
      wrap.appendChild(img);

      const podpis = document.createElement('span');
      podpis.className = 'wk-seller-caption';
      podpis.textContent = nazwa;
      wrap.appendChild(podpis);

      img.dataset.podpisane = '1';
    });

    const track = document.querySelector('.slick-track');
    if (track) {
      const ile = track.querySelectorAll('.slick-slide:not(.slick-cloned)').length;
      track.classList.toggle('is-few', ile <= 5);
    }
  }
  

  function czekaj() {
    if (document.querySelector('.wk-slider-img')) { podpisz(); return; }

    const obs = new MutationObserver(function () {
      if (document.querySelector('.wk-slider-img')) { podpisz(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', czekaj);
  } else {
    czekaj();
  }
})();
